import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { getFormattedTimezone } from 'swag-client-common/utils/time.utils';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import dynamicExampleLogo from 'assets/img/logo-dynamic.png';
import twitterDynamic from 'assets/svg/twitter_dynamic.svg';
import facebookDynamic from 'assets/svg/facebook_dynamic.svg';
import instagramDynamic from 'assets/svg/instagram_dynamic.svg';
import tiktokDynamic from 'assets/svg/tiktok_dynamic.svg';
import linkedInDynamic from 'assets/svg/linkedin_dynamic.svg';
import style from './footer-main.dynamic.scss';
const SOCIAL_ICONS = {
  twitter: twitterDynamic,
  facebook: facebookDynamic,
  instagram: instagramDynamic,
  tiktok: tiktokDynamic,
  linkedIn: linkedInDynamic
};
export const FooterMain = ({
  footerClassName = '',
  footerData
}) => {
  const copyrightYearTo = new Date().getFullYear();
  const {
    logo,
    email,
    phone,
    socials,
    scheduler,
    companyName,
    timezone,
    logoLinkUrl,
    showEmail,
    showPhone
  } = footerData;
  const timezoneFormatted = getFormattedTimezone(timezone);
  const logoLink = logoLinkUrl || '/';
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style.footer, footerClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: style.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: style.left
  }, /*#__PURE__*/React.createElement("div", {
    className: style.logoBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: style.logo
  }, /*#__PURE__*/React.createElement("a", {
    href: logoLink,
    rel: "noreferrer noopener"
  }, /*#__PURE__*/React.createElement("img", {
    src: logo || dynamicExampleLogo,
    alt: "logo"
  }))), /*#__PURE__*/React.createElement("div", {
    className: style.logoBlockBottom
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.PRIVACY_POLICY
  }, "Privacy Policy"), " |", ' ', /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.TOS
  }, "Terms of Service"), " |", ' ', /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.COMMITMENT_TO_ACCESSIBILITY
  }, "Commitment to Accessibility")), /*#__PURE__*/React.createElement("div", {
    className: style.copyright
  }, "\xA9 ", copyrightYearTo, " ", companyName, ". All Rights Reserved."))), /*#__PURE__*/React.createElement("div", {
    className: style.contactWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: style.info
  }, /*#__PURE__*/React.createElement("dl", null, showEmail || showPhone ? /*#__PURE__*/React.createElement("dt", {
    className: style.headerText
  }, "Contact") : null, showEmail && /*#__PURE__*/React.createElement("dd", null, email), showPhone && /*#__PURE__*/React.createElement("dd", null, phone))))), /*#__PURE__*/React.createElement("div", {
    className: style.right
  }, scheduler !== null && scheduler !== void 0 && scheduler.length ? /*#__PURE__*/React.createElement("div", {
    className: style.schedulerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.info, style.scheduler)
  }, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", {
    className: style.headerText
  }, /*#__PURE__*/React.createElement("span", null, "Business hours"), /*#__PURE__*/React.createElement("span", null, timezoneFormatted)), scheduler.map(sc => {
    return /*#__PURE__*/React.createElement("dd", {
      key: sc.day,
      "data-day": sc.day
    }, /*#__PURE__*/React.createElement("span", null, sc.day), sc.from && sc.to ? /*#__PURE__*/React.createElement("span", null, sc.from, " - ", sc.to) : /*#__PURE__*/React.createElement("span", null, "Closed"));
  })))) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: style.socialsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: style.socials
  }, socials.map(social => {
    return /*#__PURE__*/React.createElement("a", {
      key: social.url,
      href: social.url,
      target: "_blank",
      rel: "noreferrer noopener"
    }, /*#__PURE__*/React.createElement("img", {
      src: SOCIAL_ICONS[social.name],
      alt: "logo"
    }));
  }))))));
};